interface CandyRackText {
  title: string;
  subtitle: string;
  add: string;
  added: string;
  upgrade: string;
  upgraded: string;
  back: string;
  cart_discount_note: string;
  reject: string;
  continue_to: string;
}

interface CandyCartText {
  title: string;
  subtitle: string;
  add: string;
  added: string;
  back: string;
  continue_to: string;
  headline: string;
}

interface LastUpsellText {
  title: string;
  order_name: string;
  order_subheadline: string;
  add: string;
  added: string;
  back: string;
  continue_to: string;
  see_offers: string;
}

interface SettingsButton {
  colors: {
    background: string;
    text: string;
    border: string;
  };
  border: {
    enabled: boolean;
    width: string; // TODO ensure BE updated its impl
  };
}
interface ActionableButton {
  action: ButtonAction;
}

interface CandyRackButtons {
  close: ActionableButton;
  add: SettingsButton & ActionableButton;
  continue_to: SettingsButton & ActionableButton;
  reject: SettingsButton & ActionableButton;
}

interface CandyCartButtons {
  add: SettingsButton;
  continue_to: SettingsButton;
}

interface LastUpsellButtons {
  add: SettingsButton;
  continue_to: SettingsButton;
  see_offers: { colors: { background: string; text: string } };
}

export type PopupLayoutType = 'tree' | 'grid';

export type ImageSize = 'small' | 'medium' | 'large';

export type CandyRackSettings = {
  text: CandyRackText;
  buttons: CandyRackButtons;
  cart_discount_note: string;
  custom_css: string;
  max_popup_session_views: number;
  is_subheadline_enabled: boolean;
  is_reject_enabled: boolean;
  image_size: ImageSize;
  popup_layout: PopupLayoutType;
};

export type LastUpsellSettings = {
  text: LastUpsellText;
  buttons: LastUpsellButtons;
  custom_css: string;
  time_to_pay_upsells: number | null;
  image_size?: ImageSize;
  popup_layout?: PopupLayoutType;
};

export type CandyCartSettings = {
  text: CandyCartText;
  buttons: CandyCartButtons;
  ajax_cart_watcher_selector: string;
  discounts_enabled: string;
  custom_css: string;
  custom_cart_icon: string;
  is_subheadline_enabled: boolean;
  image_size?: ImageSize;
};

export type Settings =
  | CandyRackSettings
  | LastUpsellSettings
  | CandyCartSettings;

export type ButtonAction =
  | 'redirect_to_cart'
  | 'redirect_to_checkout'
  | 'stay_at_product_page'
  | 'theme_settings';

export const isCandyRackSettings = (
  varToBeChecked: any,
): varToBeChecked is CandyRackSettings =>
  varToBeChecked.buttons?.reject !== undefined;

export const isCandyCartSettings = (
  varToBeChecked: any,
): varToBeChecked is CandyCartSettings =>
  varToBeChecked['ajax_cart_watcher_selector'] !== undefined;

export const isLastUpsellSettings = (
  varToBeChecked: any,
): varToBeChecked is LastUpsellSettings =>
  varToBeChecked['button_color'] !== undefined;

export const isOfType = <T>(
  varToBeChecked: any,
  propertyToCheckFor: keyof T,
): varToBeChecked is T =>
  (varToBeChecked as T)[propertyToCheckFor] !== undefined;

/*
 * CandyRack is using the LastUpsellSettings for the Thank You Page. We want to enable GridLayout also there.
 */
export const isGridLayout = (settings: Settings): boolean =>
  !isCandyCartSettings(settings) && settings.popup_layout === 'grid';

export const popupLayoutCssPostfix = (settings: Settings): string =>
  isGridLayout(settings) ? '-grid' : '';
